import React from 'react';

const commonSortDescendingIcon = (<i className='sort-icon font-icon font-icon-arrow-drop-down'/>);
const commonSortAscendingIcon = (<i className='sort-icon font-icon font-icon-arrow-up'/>);

export {
    commonSortDescendingIcon,
    commonSortAscendingIcon
};
